import { render, staticRenderFns } from "./DraggableQuestionOption.vue?vue&type=template&id=234cfffd&"
import script from "./DraggableQuestionOption.vue?vue&type=script&lang=js&"
export * from "./DraggableQuestionOption.vue?vue&type=script&lang=js&"
import style0 from "./DraggableQuestionOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports